module.exports = __webpack_public_path__ + "img/rouler_positions_3_back.8cb23157.png";